<template>
<div class="wrap-date">
	<v-menu
		ref="menu2"
		:close-on-content-click="false"
		transition="scale-transition"
		offset-y
		full-width
		min-width="290px"
	>
		<v-icon slot="activator" medium>event</v-icon>
		<v-date-picker v-model="dataTimeFormated" locale="cs" />
	</v-menu>
	<v-text-field
		class="datepicker_field"
		v-model="dataTime"
		mask="##.##.####"
		return-masked-value
		:label="label"
		:error-messages="errorMessages"
		@blur="dataTime = parseDate(dataTime)"
	/>
</div>
</template>

<script>
const parseDot = date => {
	const [day, month, year] = date.split('.')
	return { day, month, year }
}

const parseDefis = date => {
	const [year, month, day] = date.split('-')
	return { day, month, year }
}
export default {
	props: {
		value: String,
		label: String,
		errorMessages: [String, Array]
	},
	computed: {
		dataTime: {
			get() {
				return this.value
			},
			set(val) {
				this.$emit('input', val)
				this.$refs.menu2.save()
			}
		},
		dataTimeFormated: {
			get() {
				if (!this.value) return ''
				let date
				if (this.value && this.value.includes('.')) {
					date = parseDot(this.value)
				} else {
					date = parseDefis(this.value)
				}
				const { year, month, day } = date

				return `${year}-${month}-${day}`
			},
			set(val) {
				const { year, month, day } = parseDefis(val)
				this.$emit('input', `${day}.${month}.${year}`)
				this.$refs.menu2.save()
			}
		}
	},
	methods: {
		parseDate(date) {
			if (!date) return null

			const { year, month, day } = parseDot(date)
			return `${day.padStart(2, '0')}.${month.padStart(2, '0')}.${year}`
		}
	}
}
</script>

<style>
.wrap-date .v-menu__activator {
	width: 24px !important;
}
.wrap-date {
	display: flex;
	justify-content: center;
	align-items: center;
}
.datepicker_field {
	margin-left: 5px;
}
</style>
